var _rect, _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveProject(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0013 16.6809C16.5085 16.6809 13.668 19.4292 13.668 22.8086C13.668 26.188 16.5085 28.9362 20.0013 28.9362C23.4941 28.9362 26.3346 26.188 26.3346 22.8086C26.3346 19.4292 23.4941 16.6809 20.0013 16.6809ZM23.5416 19.5956L20.375 22.6595C20.2713 22.7598 20.1364 22.8086 20.0013 22.8086C19.8662 22.8086 19.7311 22.7588 19.6276 22.6595C19.4218 22.4616 19.4218 22.1366 19.6276 21.9374L22.7943 18.8736C22.9988 18.6755 23.3347 18.6755 23.5406 18.8736C23.7461 19.0727 23.7472 19.3955 23.5416 19.5956Z",
    fill: "#9AF58E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3598 12.0851H22.6376C22.9279 12.0851 23.1654 11.8553 23.1654 11.5745V8.51064C23.1654 8.22979 22.9279 8 22.6376 8H17.3598C17.0685 8 16.832 8.22979 16.832 8.51064V11.5745C16.832 11.8553 17.0685 12.0851 17.3598 12.0851Z",
    fill: "#9AF58E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1111 13.8519V13.1063H17.8889V13.8519C13.6646 14.7853 10.5 18.4415 10.5 22.8085C10.5 27.8771 14.7623 32 20 32C25.2377 32 29.5 27.8771 29.5 22.8085C29.5 18.4445 26.3354 14.7863 22.1111 13.8519ZM20 29.9574C15.9256 29.9574 12.6111 26.7496 12.6111 22.8085C12.6111 18.8673 15.9256 15.6595 20 15.6595C24.0734 15.6595 27.3889 18.8673 27.3889 22.8085C27.3889 26.7496 24.0734 29.9574 20 29.9574Z",
    fill: "#9AF58E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveProject);
export default __webpack_public_path__ + "static/media/activeProject.c95824e1f8bed7aa1615e554e3264668.svg";
export { ForwardRef as ReactComponent };